
import { defineComponent } from 'vue'
import { createNamespacedHelpers } from 'vuex-composition-helpers'

const { useGetters: useSnackGetters, useActions: useSnackActions } = createNamespacedHelpers('snack')

export default defineComponent({
  name: 'Snack',
  setup() {
    const { snack } = useSnackGetters(['snack'])
    const { setSnack } = useSnackActions(['setSnack'])

    return { snack, setSnack }
  }
})
